import React from "react";
import Message from "./message";

const MessagesDropdown = () => (
  <li className="nav-item dropdown no-arrow mx-1">
    <a
      className="nav-link dropdown-toggle"
      href="/#"
      id="messagesDropdown"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i className="fas fa-envelope fa-fw"></i>
      <span className="badge badge-danger badge-counter">7</span>
    </a>

    <div
      className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
      aria-labelledby="messagesDropdown"
    >
      <h6 className="dropdown-header">Message Center</h6>
      <Message
        details={{
          body: "Hi there! I am wondering if you can help me with a problem I've been having.",
          author: "Emily Fowler",
          avatar: "https://source.unsplash.com/Mv9hjnEUHR4/60x60",
          timeAgo: "58m",
          read: false,
        }}
      />
      <Message
        details={{
          body: "I have the photos that you ordered last month, how would you like them sent to you?",
          author: "Jae Chun",
          avatar: "https://source.unsplash.com/AU4VPcFN4LE/60x60",
          timeAgo: "1d",
          read: false,
        }}
      />
      <Message
        details={{
          body: "Last month's report looks great, I am very happy with the progress so far, keep up the good work!",
          author: "Morgan Alvarez",
          avatar: "https://source.unsplash.com/CS2uCrpNzJY/60x60",
          timeAgo: "2d",
          read: true,
        }}
      />
      <a className="dropdown-item text-center small font-weight-bold" href="/#">
        MOSTRAR TODOS LOS MENSAJES
      </a>
    </div>
  </li>
);

export default MessagesDropdown;
